import classNames from "classnames";
import { Link } from "react-router-dom";
import styles from "../Digikala.module.css";

export default function DigikalaHero({ hero }) {
  return (
    <div className="row rtl d-flex justify-content-center flex-wrap text-left py-4">
      <div className="col col-12 col-md-5 d-flex flex-column justify-content-center align-middle pt-2 pb-1 flex-col">
        <h1 className="text-secondary font-weight-bold fs-2">
          <span>{hero.title.start}</span>
          <span style={{ color: hero.title.digikala.color }}>
            {hero.title.digikala.text}
          </span>
          <span>{hero.title.second}</span>
          <span style={{ color: hero.title.avaex.color }}>
            {hero.title.avaex.text}
          </span>
        </h1>

        <p className="text-dark pt-2 font-weight-bold">{hero.subtitle}</p>

        <Link
          to="/digikala/seller/information"
          className={classNames(
            "d-block mt-2 buttonUi btn-success-style text-center py-3 fs-5",
            styles.digikalaButon
          )}
          style={{ borderRadius: 15, width: 250 }}
        >
          اتصال به دیجی‌کالا
        </Link>
      </div>

      <div
        className="col col-12 col-md-7 d-flex justify-content-center pt-3"
        style={{ height: 400 }}
      >
        <img
          src={hero.imagePath}
          style={{ objectFit: "cover", width: "100%", height: "100%" }}
          className={styles.digikalaRadius}
          alt="تصویر قهرمان"
        />
      </div>
    </div>
  );
}
